import './bootstrap';
import '../css/app.css';

import { createApp } from 'vue';
import DashboardManager from './Components/DashboardManager.vue';
import PropertySelectorStep from './Components/PropertySelectorStep.vue';
import LeaderboardView from './Components/LeaderboardView.vue';

const app = createApp({
    components: {
        DashboardManager,
        PropertySelectorStep,
        LeaderboardView
    },
});
app.mount('#app');
